module.exports = __webpack_public_path__ + "img/hero-profile-hand.c706fccf.webp";